require('./bootstrap');
require('docx-preview');

// require('formiojs');

/*
require('flatpickr');
const { German } = require('flatpickr/dist/l10n/de.js'); */

// (window).flatpickr.localize(German);
// window.German = German;
// console.log(German);
/* window.flatpickr = {};
window.flatpickr.l10ns = {
  'en': {
    'weekdays': {
      'shorthand': [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat',
      ],
      'longhand': [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ],
    },
    'months': {
      'shorthand': [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
      'longhand': [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
    },
    'daysInMonth': [
      31,
      28,
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31,
    ],
    'firstDayOfWeek': 0,
    'rangeSeparator': ' to ',
    'weekAbbreviation': 'Wk',
    'scrollTitle': 'Scroll to increment',
    'toggleTitle': 'Click to toggle',
    'amPM': [
      'AM',
      'PM',
    ],
    'yearAriaLabel': 'Year',
    'monthAriaLabel': 'Month',
    'hourAriaLabel': 'Hour',
    'minuteAriaLabel': 'Minute',
    'time_24hr': false,
  },
  'default': {
    'weekdays': {
      'shorthand': [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa',
      ],
      'longhand': [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag',
      ],
    },
    'months': {
      'shorthand': [
        'Jan',
        'Feb',
        'Mär',
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez',
      ],
      'longhand': [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
      ],
    },
    'daysInMonth': [
      31,
      28,
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31,
    ],
    'firstDayOfWeek': 1,
    'rangeSeparator': ' bis ',
    'weekAbbreviation': 'KW',
    'scrollTitle': 'Zum Ändern scrollen',
    'toggleTitle': 'Zum Umschalten klicken',
    'amPM': [
      'AM',
      'PM',
    ],
    'yearAriaLabel': 'Year',
    'monthAriaLabel': 'Month',
    'hourAriaLabel': 'Hour',
    'minuteAriaLabel': 'Minute',
    'time_24hr': true,
  },
  'de': {
    'weekdays': {
      'shorthand': [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa',
      ],
      'longhand': [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag',
      ],
    },
    'months': {
      'shorthand': [
        'Jan',
        'Feb',
        'Mär',
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez',
      ],
      'longhand': [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
      ],
    },
    'firstDayOfWeek': 1,
    'weekAbbreviation': 'KW',
    'rangeSeparator': ' bis ',
    'scrollTitle': 'Zum Ändern scrollen',
    'toggleTitle': 'Zum Umschalten klicken',
    'time_24hr': true,
  },
}; */

/* const { datetime: DateTime } = Formio.Components.components;
const { attach } = DateTime.prototype;


DateTime.prototype.attach = function(...args) {
  console.log(window.flatpicker);
  return attach.apply(this, args);
};
 */

// Formio.createForm(document.getElementById('formio'), form);

// load german locale

/* const de={weekdays:{shorthand:["So","Mo","Di","Mi","Do","Fr","Sa"],longhand:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"]},months:{shorthand:["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],longhand:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"]},firstDayOfWeek:1,weekAbbreviation:"KW",rangeSeparator:" bis ",scrollTitle:"Zum Ändern scrollen",toggleTitle:"Zum Umschalten klicken",time_24hr:!0};
            //window.flatpickr = window.flatpickr || {};
            //window.flatpickr.l10ns = window.flatpickr.l10ns || {};
            //window.flatpickr.l10ns.de = de;
            //window.flatpickt.l10ns.default = de;

            const { datetime: DateTime } = Formio.Components.components
            const { attach } = DateTime.prototype

            DateTime.prototype.attach = function(...args) {
            this.component.widget.locale = this.options.language || 'en'
            return attach.apply(this, args)
            } */


// dateTime.customOptions = {locale: de};
